import React from "react";
import { Card, CardContent, Stack, Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
export const AwaitingFeedbackCard = () => {
  return (
    <Card sx={{ width: "100%", mt: 2 }}>
      <CardContent>
        <Stack direction={"column"} spacing={1}>
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <InfoOutlined fontSize="small" color="action" />
            <Typography variant="subtitle2" color="text.secondary">
              Feedback pending
            </Typography>
          </Stack>
          <Typography variant="body2">
            Your teacher hasn’t released feedback yet.
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};
